module.exports = __webpack_public_path__ + "img/hfri_gr.1099962b.png";